<template>
    <div>
        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content" v-if="paso0" key="paso0" id="paso0">
                <div class="container">
                    <div class="row">
                        <div class="col-12 mb-2">
                            <h2 class="h1 text-uppercase">{{ configuracion.hash_teatro !== 'XSb8uxOmqRUI9fMC3Kos' ? 'Buscar abono' : 'Empresa' }}</h2>
                            <p v-if="configuracion.hash_teatro == 'OUMWXI3wSRdsZaf7g5iE'">
                                Introduce DNI o NIF. Recuerda poner tu número de abonado sin letras. Si tu número es S0004, escribe 4.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="row">
                                <div class="col-12">
                                    <BuscarAbonadoComponent :abonado="abonado_search" v-on:terminado="buscarAbonado"/>
                                </div>
                                <div v-if="buscando" class="col-12">
                                    <LoaderComponent/>
                                </div>
                                <div class="col-12" v-if="error">
                                    <section class="padding-vertical-content">
                                        <div class="container">
                                            <div class="row">
                                                <div class="col-12 pl-0">
                                                    <div class="alert alert-danger" role="alert">
                                                        <div v-if="error != 'comprado'">
                                                            <template v-if="motivo == 'superado_maximo_numero_de_pedidos'">
                                                                <h4>El número de abono que estás introduciendo ya ha superado el número máximo de pedidos.</h4>
                                                            </template>
                                                            <template v-else-if="motivo == 'no_permitido'">
                                                                <p>El número de abono que estás introduciendo está fuera del rango permitido para este partido / momento.</p>
                                                            </template>
                                                            <template v-else-if="motivo == 'maximo_numero_pedidos_es_0'">
                                                                <h4>En este evento no se permite comprar entradas como abono amig@.</h4>
                                                            </template>
                                                            <template v-else-if="motivo == 'no_renovado'">
                                                                <h4>{{ $t('partidos.abonado_no_renovado') }}</h4>
                                                            </template>
                                                            <template v-else>
                                                                <h4>{{ error }}</h4>
                                                                <p>Por favor, escriba un correo a {{ manager.email_incidencias || 'info@compralaentrada.com' }} indicando su numero de abonado, nombre, apellidos y dni.</p>
                                                                <p v-if="configuracion.hash_teatro == 'I0QtpDfZsTkgWKert1Gp'">
                                                                    En el caso de que no exista tu número de abonado contacte con en club en:

                                                                    Teléfono de contacto: 968.012.412
                                                                    Email de contacto: {{ manager.email_incidencias || 'info@compralaentrada.com' }}
                                                                </p>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 mt-3 pl-0" v-if="configuracion.hash_teatro !== 'XSb8uxOmqRUI9fMC3Kos'">
                            <p class="text-center-sm"><b>Abono amig@</b></p>
                            <ul class="text-justify-sm">
                                <li>El club pone a disposición de los abonados la posibilidad de retirar entradas a precios exclusivos</li>
                                <li>El acceso es de carácter nominativo, es decir, para acceder al estadio presentando el abono o entrada acompañado de un documento oficial de identidad, dado que puede ser solicitado en el control de acceso.</li>
                                <li>El abono para la temporada es personal e intransferible. Deben coincidir con los datos que aparecen en el carnet/entrada de abonado con los del documento oficial de identidad.</li>
                                <li>Rogamos que el usuario acuda al estadio con tiempo suficiente para tener un acceso fluido y cumpliendo con toda normativa sanitaria.</li>
                                <li>Recibe las entradas en el correo electrónico que nos indiques</li>
                            </ul>
                            <p class="text-center-sm"><b>Cualquier cuestión nos tienes en {{ manager.email_incidencias || 'info@compralaentrada.com' }}</b></p>
                        </div>
                    </div>
                </div>
            </section>
        </transition>
        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content" v-if="paso1" key="paso1" id="paso1">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">Selecciona tus entradas</h2>
                        </div>
                        <div class="col-12">
                            <transition name="fade" mode="out-in">
                                <div class="row" v-if="zonas" key="zonas" id="zonas">
                                    <div class="col-lg-8">
                                        <h3 class="subtitle h3 light mb-3 ">A) Selecciona el sector pinchando en el mapa:</h3>
                                        <div class="lightgray-content">
                                            <div>
                                                <SvgComponent
                                                    :zonas="zonas_formated"
                                                    :place="event.place"
                                                    :sesion_id="sesion_id"
                                                    @clickZona="finalizarPasoUno"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-4">
                                        <h3 class="subtitle h3 light mb-3 ">B) O en la siguiente tabla:</h3>
                                        <div class="lightgray-content p-2 pb-0">
                                            <TablaSectoresComponent :zonas="zonas_formated" v-on:goTo="finalizarPasoUno"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-else>
                                    <div class="col-12 text-center" style="height: 400px">
                                        <LoaderComponent/>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
            </section>
        </transition>
        <VisibilidadReducida :zona="zona" @aceptar="AceptarVisibilidadReducida"/>
        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content" v-if="paso2" key="paso2" id="paso2">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">Elige tus asientos</h2>
                            <h3 class="subtitle h3 light mb-3 ">Si lo deseas, también puedes escoger varios asientos a la vez</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <div class="oswald text-uppercase">Zona seleccionada:</div>
                            <span class="h2 mb-1 d-block">{{ zona.name }} <button class="h6 button small-button m-0" @click="volver" :disabled="paso3"><i class="fa fa-redo"></i> Cambiar</button></span>

                            <div v-if="zona.imagen" class="mb-3">
                                <img :src="zona.imagen"/>
                            </div>
                            <div v-if="asientos_maximos > 1" class="alert alert-primary mb-3" role="alert">
                                <b>Puedes añadir acompañantes seleccionando varias butacas</b>
                            </div>
                            <!--<h3>{{ zona.precios[0].precio }} € ({{ zona.precios[0].descripcion }})</h3>-->
                            <SelectorZonaComponent :zona="zona" :zonas="zonas"/>
                            <TusAsientosComponent 
                                :precios="zona.precios_amigo_abonado" 
                                :precios_acompanante="zona.precios_amigo_abonado" 
                                :asientos="asientos" 
                                v-on:continuar="bloquearAsientos" 
                                :puedo_cambiar="paso3 ? false : true"
                                :asientos_minimos="asientos_minimos"
                                :event="event"
                                :puedo_continuar="! paso3"
                            />
                            <div class="d-flex justify-content-between align-items-center alert alert-danger mt-2" v-if="error_bloqueo">
                                {{ error_bloqueo }}
                                <button class="h6 button small-button m-0" @click="volver" :disabled="paso3"><i class="fa fa-redo"></i> Cambiar</button>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 order-first order-lg-last">
                            <div v-if="zona.with_seats">
                                <AsientosComponent :zona="zona" :asientos="asientos" :asientos_maximos="asientos_maximos" :puedo_cambiar="paso3 ? false : true"/>
                            </div>
                            <div v-else>
                                <p class="oswald text-uppercase mt-lg-4">Seleccione el numero de entradas</p>
                                <div class="form-group">
                                    <multiselect
                                        v-model="n_entradas"
                                        placeholder="Seleccionar número de entradas"
                                        :show-labels="false"
                                        :options="options"
                                        :allow-empty="false"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </transition>
        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content lightgray-content" v-if="paso3" key="paso3" id="paso3">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <DatosCompradoresComponent 
                                @cambiar-asiento="cambiarAsiento" 
                                :datos_compradores="datos_compradores" 
                                :generos="generos" 
                                :solicitar_datos="event.solicitar_datos" 
                                :reserva_instalaciones="event.reserva_instalaciones" 
                                :asientos="asientos" 
                                v-on:terminar="guardarDatos" 
                                :loading="loading" 
                                :fields="event.fields" 
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </transition>

        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content" v-if="resumen" key="resumen" id="resumen">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">Resumen de compra</h2>
                            <div class="subtitle h3 light mb-3 mb-lg-5">Revisa los datos y completa tu pedido.</div>
                            <ResumenCompraComponent 
                                :entradas="asientos" 
                                :formulario="formulario"
                                :event="event"
                                :session_id="session_id"
                                :datos="datos_compradores"
                                @terminado="procesarPago"
                                @volver="resumen = false"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </transition>

        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content lightgray-content" v-if="procesar_pago" key="pago" id="pago">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ $t('compra.confirmacion_compra') }}</h2>
                            <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('compra.introduce_datos') }}</div>
                            <PagoPaycometComponent
                                ref="pago"
                                tipo_venta="evento"
                                :jet_id="jet_id"
                                :session_id="session_id"
                            />		
                        </div>
                    </div>
                </div>
            </section>
        </transition>
    </div>
</template>

<script>
    import BuscarAbonadoComponent from '@/components/frontend/events/compra/BuscarAbonadoComponent';
    import SvgComponent from '@/components/svg/SvgComponent';
    import TablaSectoresComponent from '@/components/frontend/events/compra/TablaSectoresComponent';
    import AsientosComponent from '@/components/frontend/events/compra/AsientosComponent';
    import SelectorZonaComponent from '@/components/frontend/events/compra/SelectorZonaComponent';
    import TusAsientosComponent from '@/components/frontend/events/compra/TusAsientosComponent';
    import DatosCompradoresComponent from '@/components/frontend/events/compra/DatosCompradoresComponent';
    import ResumenCompraComponent from '@/components/frontend/events/compra/ResumenCompraComponent';
    import Generos from "@/mixins/Generos";
    import PagoPaycometComponent from '@/components/frontend/compra/components/PagoPaycometComponent.vue';
    import VisibilidadReducida from '@/components/frontend/components/modals/VisibilidadReducida.vue';

    export default {
        props: ['event', 'sesion_id', 'tiempoTerminado'],
        mixins: [Generos],
        data() {
            return {
                zonas: null,
                zona: null,
                asientos: [],
                paso0: true,
                paso1: false,
                paso2: false,
                paso3: false,
                resumen: false,
                loading: false,
                session_id: null,
                datos_compradores: {},
                formulario: null,
                n_entradas: 0,
                entradas_compradas: 0,
                abonado_search: {
                    dni: null,
                    n_abonado: null
                },
                error: null,
                buscando: false,
                asientos_maximos: 0,
                asientos_minimos: 1,
                motivo: null,
                amigo_abonado_id: null,
                procesar_pago: false,
                jet_id: null,
                error_bloqueo: null,
                errors: null,
                region_abonado: null
            }
        },
        created() {
            this.asientos_maximos = this.asientos_maximos + this.event.n_acompanantes;
            this.asientos_minimos = this.event.n_acompanantes_min;
            this.getZonas();
            this.getGeneros();
        },
        beforeDestroy() {
            if (this.procesar_pago) {
                this.$refs.pago.clearAllIntervals();
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            entradas_disponibles() {
                return this.zona.libres;
            },
            options() {
                var tope = this.event.n_acompanantes;

                if(this.entradas_disponibles < tope) {
                    tope = this.entradas_disponibles;
                }

                if(this.entradas_compradas > 0) {
                    tope = tope - this.entradas_compradas;
                }

                var opciones = [];

                for(var i = 1; i <= tope; i++) {
                    opciones.push(i);
                }

                return opciones;
            },
            zonas_formated() {
                var array = [];

                for(const zona in this.zonas) {
                    let seccion_disponible = true;

                    if(this.event.seccion == 1 && this.zonas[zona].section_id != this.region_abonado) {
                        seccion_disponible = false;
                    }

                    const zonaObj = {...this.zonas[zona]};
                    var precios_array = [];

                    for(const pa in zonaObj.precios_amigo_abonado) {
                        const precio = zonaObj.precios_amigo_abonado[pa];
                        precios_array.push(precio)
                    }

                    zonaObj.precios = precios_array;
                    var disponible = precios_array.length > 0 && zonaObj.esta_disponible ? true : false;
                    if (zonaObj.libres <= 0 || !seccion_disponible) {
                        disponible = false;
                    }
                    zonaObj.esta_disponible = disponible;

                    array.push(zonaObj);
                }

                return array;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
        },
        mounted() {
            if(this.event.amigo_abonado == false) {
                this.$router.push({name: "front.eventos.index"});
            }
        },
        watch: {
            n_entradas() {
                var datos = [];
                for (var i = 0; i < this.n_entradas; i++) {
                    datos.push({
                        'apellidos': '',
                        'asiento': {
                            'zona_id': this.zona.id,
                            'asiento': 0,
                            'fila': 0,
                            'zona_nombre': this.zona.name
                        },
                        'dni': '',
                        'es_nuevo': true,
                        'nombre': '',
                        'precio': null,
                        'precios': this.zona.precios,
                        'telefono': '',
                        'url_imprimir': ''
                    });
                }

                this.asientos = datos;
            },
            tiempoTerminado(tiempoTerminado) {
                if (tiempoTerminado) {
                    this.recargar();
                }
            }
        },
        methods: {
            cambiarAsiento() {
                this.borrarSesion(this.session_id);
                this.paso3 = false;
                this.resumen=null;
            },
            recargar() {
                if (this.procesar_pago) {
                    this.$refs.pago.clearAllIntervals();
                }
                this.$emit('reset')
            },
            procesarPago(precio_cero = false) {
                if (precio_cero) {
                    this.procesarCompraPrecioCero();
                } else {
                    this.procesar_pago = true;
                    this.$nextTick(() => {
                        this.scrollTo('#pago')
                    })
                }
            },
            procesarCompraPrecioCero() {
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    carrito_id: this.session_id
                }
                this.$store.dispatch(this.config.getVuexAlias('front.events.procesar-compra-precio-cero'), params).then(res => {
                    this.$router.push(`/compra/${this.session_id}/${res.data.n_pedido}`);
                }).finally(() => this.loading = false);
            },
            seleccionarNuenoAsiento() {
                this.asientos = [];
                this.paso1 = true;
            },
            buscarAbonado() {
                this.error = false;
                this.buscando = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        dni: this.abonado_search.dni,
                        n_abonado: this.abonado_search.n_abonado,
                        evento_id: this.event.id,
                        sesion_id: this.sesion_id
                    },
                }

                this.$store.dispatch(this.config.getVuexAlias('front.abonados.buscar-amigo'), params).then(res => {
                    this.asientos = [];
                    this.amigo_abonado_id = res.data.id;
                    this.region_abonado = res.data.asiento?.region?.section_id;
                    this.seleccionarNuenoAsiento();
                    this.asientos_maximos = this.asientos_maximos - res.data.entradas_compradas;
                    this.entradas_compradas = res.data.entradas_compradas;
                }).catch(error =>  {
                    this.motivo = error.response.data.motivo;
                    this.error = 'El abonado no existe';
                }).finally(() => {
                    this.buscando = false;
                    this.loading = false;
                });
            },
            reset() {
                this.asientos = [];
                this.datos_compradores = {};
                this.zona = null;
            },
            getZonas() {
                this.loading = true;

                const params = {
                    filters: {
                        sesion_id: this.sesion_id
                    },
                }

                this.$store.dispatch(this.config.getVuexAlias('front.zonas.index'), params).then(res => {
                    this.zonas = res.data.data;
                }).finally(() => this.loading = false);
            },
            volver() {
                this.borrarSesion(this.session_id);
                this.datos_compradores = {};
                this.asientos = [];
                this.buscarAbonado();
                this.zona = null;
                this.paso1 = true;
                this.paso2 = false;
                this.paso3 = false;
                this.getZonas();
            },
            finalizarPasoUno(zona) {
                this.zona = zona;
                if(zona.visibilidad_reducida){
                    this.$modal.show('visibilidad-reducida');
                }
                this.paso1 = false;
                this.paso2 = true;
                this.$nextTick(function() {
                    this.scrollTo('#paso2');
                });
            },
            bloquearAsientos() {
                this.loading = true;

                var seats = [];

                for(var i in this.asientos) {
                    if(i == 0) {
                        this.asientos[i].nombre = this.datos_compradores.nombre;
                        this.asientos[i].apellidos = this.datos_compradores.apellidos;
                    }
                    seats.push(this.asientos[i].asiento);
                }

                const params = {
                    filters: {
                        sesion_id: this.sesion_id,
                        tid: this.configuracion.hash_teatro
                    },
                    zona_id: this.zona.id,
                    asientos: seats,
                    tid: this.configuracion.hash_teatro
                }

                this.$store.dispatch(this.config.getVuexAlias('front.bloquear.asientos'), params).then(res => {
                    this.session_id = res.data.session_id;
                    this.paso3 = true;
                    this.$nextTick(function() {
                        this.scrollTo('#paso3');
                    });
                }).catch(error => {
                    this.error_bloqueo = error.response.data.message;
                }).finally(() => this.loading = false);
            },
            guardarDatos(info_entradas) {
                this.loading = true;

                this.datos_compradores.asientos = this.asientos;
                this.datos_compradores.amigo_abonado_id = this.amigo_abonado_id;

                const params = {
                    filters: {
                        sesion_id: this.sesion_id,
                        tid: this.configuracion.hash_teatro
                    },
                    datos_compradores: this.datos_compradores,
                    session_id: this.session_id,
                    tid: this.configuracion.hash_teatro,
                }

                this.$store.dispatch(this.config.getVuexAlias('front.guardar.datos.comprador'), params).then(res => {
                    this.jet_id = res.data.jet_id;
                    this.formulario = res.data.formulario;
                    this.resumen = true;
                    this.$nextTick(function() {
                        this.scrollTo('#resumen');
                    });
                }).catch(error => {
                    if (error.response.data.message == 'Campos requeridos') {
                        this.errors = error.response.data.errors;
                    } else {
                        this.$toast.error(error.response?.data?.message);
                    }
                }).finally(() => this.loading = false);
            },
            scrollTo(paso) {
                this.$scrollTo(paso, 100)
            },
            borrarSesion(session_id) {
                const params = {
                    filters: {
                        session_id: session_id,
                        tid: this.configuracion.hash_teatro
                    },
                    session_id: session_id,
                    tid: this.configuracion.hash_teatro
                }

                this.$store.dispatch(this.config.getVuexAlias('front.sesion.delete'), params);
            },
            AceptarVisibilidadReducida(){
                this.$modal.hide('visibilidad-reducida');
            }
                
        },
        components: {
            TablaSectoresComponent, AsientosComponent,
            SelectorZonaComponent, TusAsientosComponent, DatosCompradoresComponent,
            ResumenCompraComponent, BuscarAbonadoComponent, SvgComponent, PagoPaycometComponent,
            VisibilidadReducida
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    @media (max-width: 768px) {
        .text-justify-sm {
            text-align: justify;
            margin-right: 0.7em;
        }
        .text-center-sm {
            text-align: center;
        }
        .alert {
            width: 85vw !important;
        }
    }
</style>
